// 标签类型枚举
export enum TagType {
  TAG_TYPE_UNSPECIFIED = 0, // 未指定
  TAG_TYPE_CATEGORY = 1, // 分类
  TAG_TYPE_PAGE_TYPE = 2, // 页面类型
  TAG_TYPE_VISUAL_STYLE = 3, // 视觉风格
}

// 标签实体
export interface Tag {
  id: string; // 唯一标识（自增ID）
  key: string; // 标签标识符（唯一，用于API筛选）
  name: string; // 显示名称
  type: TagType; // 标签类型
  // protobuf int64 在 JSON 中可能被序列化为字符串或数字
  created_at: string | number; // 创建时间戳
}

// 创建标签请求
export interface CreateTagRequest {
  type: TagType; // 标签类型（必填）
  key: string; // 标签标识符（必填，唯一）
  name: string; // 显示名称（必填）
}

// 创建标签响应
export interface CreateTagReply {
  success: boolean; // 是否成功
  message?: string; // 消息
  tag: Tag; // 创建的标签
}

// 获取标签请求
export type GetTagRequest =
  | { type: TagType; id: string; key?: never }
  | { type: TagType; id?: never; key: string };

// 获取标签响应
export interface GetTagReply {
  tag: Tag; // 标签详情
}

// 更新标签请求
export interface UpdateTagRequest {
  type: TagType; // 标签类型（必填）
  id: string; // 标签ID（必填）
  key?: string; // 标签标识符（可选）
  name?: string; // 显示名称（可选）
}

// 更新标签响应
export interface UpdateTagReply {
  success: boolean; // 是否成功
  message?: string; // 消息
  tag: Tag; // 更新后的标签
}

// 删除标签请求
export interface DeleteTagRequest {
  type: TagType; // 标签类型（必填）
  id: string; // 标签ID（必填）
}

// 删除标签响应
export interface DeleteTagReply {
  success: boolean; // 是否成功
  message?: string; // 消息
}

// 列表查询标签请求
export interface ListTagsRequest {
  type: TagType; // 标签类型（必填）
  keyword?: string; // 关键词搜索key或name（可选）
}

// 列表查询标签响应
export interface ListTagsReply {
  tags: Tag[]; // 标签列表
  total: number; // 总数
}
